/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { api } from '@/lib/api';
import { fmtDateTime } from '@/lib/format';
import { Button, Empty, Input, Select } from './ui';

const KIND: Record<string, string> = {
  NOTE: 'Заметка', CALL: 'Звонок', EMAIL: 'Письмо', MESSAGE: 'Сообщение', MEETING: 'Встреча', DOCUMENT: 'Документ', PAYMENT: 'Платёж', STAGE: 'Этап', SYSTEM: 'Система',
};

/** Лента взаимодействий карточки (клиента или дела) с быстрым добавлением записи. */
export function Timeline({ path, canWrite }: { path: string; canWrite: boolean }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['timeline', path], queryFn: () => api.get(path) });
  const [kind, setKind] = useState('NOTE');
  const [title, setTitle] = useState('');
  const add = useMutation({
    mutationFn: () => api.post(path, { kind, title }),
    onSuccess: () => { setTitle(''); qc.invalidateQueries({ queryKey: ['timeline', path] }); },
  });
  const submit = (e: FormEvent) => { e.preventDefault(); if (title.trim()) add.mutate(); };
  return (
    <div>
      {canWrite && (
        <form onSubmit={submit} className="mb-4 flex gap-2">
          <Select className="max-w-[150px]" value={kind} onChange={(e) => setKind(e.target.value)}
            options={['NOTE', 'CALL', 'EMAIL', 'MESSAGE', 'MEETING'].map((k) => ({ value: k, label: KIND[k] }))} />
          <Input placeholder="Что произошло" value={title} onChange={(e) => setTitle(e.target.value)} />
          <Button type="submit" disabled={add.isPending}>Добавить</Button>
        </form>
      )}
      {!data?.length ? <Empty>Записей пока нет</Empty> : (
        <ol className="relative space-y-3 border-l border-slate-200 pl-4">
          {data.map((e: any) => (
            <li key={e.id}>
              <div className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border-2 border-white bg-brand-500" />
              <div className="text-xs text-slate-500">{fmtDateTime(e.at)} · {KIND[e.kind] ?? e.kind}</div>
              <div className="text-sm">{e.title}</div>
              {e.body && <div className="text-sm text-slate-600">{e.body}</div>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
